import React from "react";
import Logo, { LogoType } from "../../Components/Logo/Logo";
import deFlag from "../../assets/flags/de-flag.svg";
import ukFlag from "../../assets/flags/uk-flag.svg";
import CountrySelection from "../../Components/CountrySelection/CountrySelection";
import "./CountrySelectionPage.css";

const CountrySelectionPage: React.FC = () => {
  return (
    <div className="country-selection-container">
      <div className="medium-layout country-selection-container-inner">
        <div className="flex flex-col content-center items-center text-center">
          <Logo type={LogoType.Vertical} />
          <div className="country-selection-headline-container">
            <h1 className="country-selection-headline">Welcome to Nelia</h1>
            <p className="grey">Please chose your preferred language</p>
          </div>
        </div>
        <div className="country-grid">
          <CountrySelection
            countryName="Germany"
            countryFlagPath={deFlag}
            countryPath="germany"
          />
          <CountrySelection
            countryName="United Kingdom"
            countryFlagPath={ukFlag}
            countryPath="uk"
          />
        </div>
      </div>
    </div>
  );
};

export default CountrySelectionPage;
